import type { Accept } from 'react-dropzone'

const extensionLabels = (accept: Accept) =>
  Object.values(accept)
    .flat()
    .map((extension) => extension.replace(/^\./, '').toUpperCase())

export const formatDropzoneHint = (accept?: Accept, maxSize?: number) => {
  const parts: string[] = []
  const labels = accept ? extensionLabels(accept) : []
  if (labels.length > 0) {
    const suffix = labels.length === 1 ? ' only' : ''
    parts.push(`${labels.join(', ')}${suffix}`)
  }
  if (maxSize) parts.push(`up to ${maxSize} MB per file`)
  return parts.join(' · ')
}
